import aoflModules, {
  store as storeService
} from 'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min';
import toastrConfig from './toastr-config';
import {isMobile} from '@aoflmkt/is-mobile';

const initServiceImpl = function riqInitService(
  $rootScope,
  accessControlService,
  PageareaTracker,
  $state,
  applicationDebug,
  riqErrorHandlerService,
  riqAuthService,
  riqToastrService,
  riqAnalyticsService,
  riqApiService,
  ClickTracker,
  featureService
) {
  const _this = this;
  const _errFn = riqErrorHandlerService.getErrorFactory('riqInitService');
  const mainErrElement = document.querySelector(
    '.js-ReadingIQ__main-error-msg'
  );
  let redirectLink;

  if (isMobile.any) {
    document.body.classList.add('is-mobile');
  }

  window.riqStateStore = storeService;
  window.aoflModules = aoflModules;

  const _processNewsfeed = function _processNewsfeed(token) {
    return riqApiService
      .get('processNewsfeed', {token: token, platform: 'web'})
      .catch(console.error);
  };

  function _onAuthSuccess() {
    localStorage.setItem('lastPasswordEntered', Date.now());
    const state = storeService.getState();

    // eventually this processing will be moved to an offline job on a cadence
    // and can be removed from inside the app
    _processNewsfeed(state.appSession.token);

    if (state.user.onboardingStep) {
      return $state.go('onboarding_en').catch(function() {
        // Retry again to the redirect as a workaround state-transition prevented error
        return $state.go('onboarding_en').catch(function() {
          return $state.go('onboarding_en');
        });
      });
    }

    if (!state.profile.profileUuid) {
      return $state.go('select_profile_en').catch(function() {
        // Retry again to the redirect as a workaround state-transition prevented error
        return $state.go('select_profile_en');
      });
    }

    if (redirectLink) {
      const newUrl = window.location.href + redirectLink;
      window.history.replaceState({path: newUrl}, '', newUrl);
      window.location.reload();
      return;
    }

    const isInitalStateOnboarding =
      $rootScope.initialState &&
      $rootScope.initialState.url.indexOf('onboarding') > -1;
    const isUserOnboarded = state.user.ftue === 1;
    const isClassLoginLocked = localStorage.getItem('riqClassLoginLock');

    if (
      $rootScope.initialState &&
      !(isInitalStateOnboarding && isUserOnboarded)
    ) {
      if (isClassLoginLocked) {
        return $state.go('class_login_en').catch(function() {
          // Retry again to the redirect as a workaround state-transition prevented error
          return $state.go('class_login_en');
        });
      }

      return $state
        .go($rootScope.initialState, $rootScope.initialStateParams)
        .catch(function() {
          // Retry again to the redirect as a workaround state-transition prevented error
          return $state.go(
            $rootScope.initialState,
            $rootScope.initialStateParams
          );
        });
    }

    return $state.go(state.user.homepage.route).catch(function() {
      // Retry again to the redirect as a workaround state-transition prevented error
      return $state.go(state.user.homepage.route);
    });
  }

  function _bindListeners() {
    $rootScope.$on('$stateChangeStart', function(
      event,
      toState,
      toStateParams,
      fromState,
      fromStateParams
    ) {
      if (toState.name !== 'teacher_dashboard_en' && isMobile.any) {
        // eslint-disable-next-line
        if (!applicationDebug) {
          window.location.href = '/download-app';
        } else {
          console.error('/download-app redirect');
        }
      }
      /* eslint-disable no-undef */
      if (window.ga) {
        // ga is a global defined by google-analytics script (see /index.html file)
        ga('set', 'page', toState.url);
        ga('send', 'pageview');
      }
      /* eslint-enable no-undef */
      const state = storeService.getState();
      const user = state.user;

      const isFromBehindPasswordGate = fromState.url.includes('settings');
      const isToBehindPasswordGate = toState.url.includes('settings');

      const isClassLoginLocked = localStorage.getItem('riqClassLoginLock');

      storeService.commit([
        {
          stateAlias: 'pagearea',
          mutationId: 'setPreviousState',
          payload: {
            name: fromState.name,
            params: fromStateParams
          }
        },
        {
          stateAlias: 'pagearea',
          mutationId: 'setNextState',
          payload: {
            name: toState.name,
            params: toStateParams
          }
        }
      ]);

      if (
        accessControlService.can('view_teacher_dashboard') &&
        toState.name === 'my_account_en'
      ) {
        event.preventDefault();
        $state.go('teacher_dashboard_en');
      }

      /*
      (daniel.mendoza) INFOSEC-470: Prevent student user from directly going to any
      the teacher exclusive pages by inputting the URL or creating a new tab.
      */
      if (isClassLoginLocked && toState.name !== 'class_login_en') {
        event.preventDefault();
        return $state.go('class_login_en').catch(function() {
          // Retry again to the redirect as a workaround state-transition prevented error
          return $state.go('class_login_en');
        });
      }

      if (!accessControlService.canViewState(toState)) {
        event.preventDefault();
        // eslint-disable-next-line no-console
        console.warn('User does not have access to ' + toState.name);
        storeService.commit([
          {
            stateAlias: 'riqToastrs',
            mutationId: 'show',
            payload: 'restrictedAccess'
          }
        ]);

        return $state.go(state.user.homepage.route);
      }

      // password gate
      if (isFromBehindPasswordGate && !isToBehindPasswordGate) {
        storeService.commit([
          {
            stateAlias: 'user',
            mutationId: 'update',
            payload: {authenticated: false}
          }
        ]);
      }
      if (isToBehindPasswordGate) {
        const isGroupOwner = state.profile.isGroupOwner;
        const lastPasswordEntered = localStorage.getItem('lastPasswordEntered');
        const timeNow = Date.now();
        const passwordEnteredLessThanTwoMinutesAgo =
          timeNow - lastPasswordEntered < 120000;
        if (
          !user.authenticated &&
          !passwordEnteredLessThanTwoMinutesAgo &&
          !isGroupOwner &&
          !redirectLink
        ) {
          event.preventDefault();
          if (!storeService.getState().riqModals) {
            $state.go('my_shelf_en', {change: ''});
          }
          storeService.commit([
            {
              stateAlias: 'riqModals',
              mutationId: 'show',
              payload: 'passwordModal'
            }
          ]);
        }
      }
    });

    $rootScope.$on('$stateChangeSuccess', function() {
      // Always Hide default error section, on stateChangeSuccess
      // We don't want the error section to overlay our app.
      mainErrElement.style.display = 'none';
    });
  }

  const initAnalytics = function initAnalytics() {
    const documentClickTracker = new ClickTracker(
      riqAnalyticsService,
      document.body
    );
    const pageareaTracker = new PageareaTracker(riqAnalyticsService);

    riqAnalyticsService
      .getAnalyticsQueue()
      .track('documentClick', documentClickTracker);
    riqAnalyticsService.getAnalyticsQueue().track('page-area', pageareaTracker);
    riqAnalyticsService.resetInterval();
  };

  const sendAppStartEvent = function() {
    try {
      const state = storeService.getState();
      const appSession = state.appSession;
      const {
        appName,
        appFilter,
        appVersion,
        userAgent,
        graphicsType,
        graphicsVersion,
        devicePixelRatio,
        shortSideLogicalPixels,
        longSideLogicalPixels,
        operatingSystem
      } = appSession;
      riqAnalyticsService.enqueueEvent({
        eventType: 'AOFL.READINGIQ_PRIVATE.V1.ApplicationEvent',
        payload: {
          deviceInfo: {
            appName,
            appFilter,
            appVersion,
            userAgent,
            graphicsType,
            graphicsVersion,
            devicePixelRatio,
            shortSideLogicalPixels,
            longSideLogicalPixels,
            operatingSystem
          },
          type: 'Started'
        }
      });
    } catch (e) {}
  };

  _this.init = function(token, deviceId, deepLinkRedirect, altToken) {
    $rootScope.can = accessControlService.can;
    $rootScope.isWebPSupported = window.aofljsConfig.isWebPSupported;
    $rootScope.getUserText = accessControlService.getUserText;
    initAnalytics();
    _bindListeners();
    riqToastrService.registerToastr(toastrConfig);
    redirectLink = deepLinkRedirect;
    if (token) {
      storeService.commit([
        {
          stateAlias: 'appSession',
          mutationId: 'setToken',
          payload: token
        },
        {
          stateAlias: 'appSession',
          mutationId: 'setDeviceId',
          payload: deviceId
        }
      ]);
      return riqAuthService
        .auth(token)
        .catch(function(_err) {
          if (altToken && altToken !== token) {
            storeService.commit([
              {
                stateAlias: 'appSession',
                mutationId: 'setToken',
                payload: altToken
              }
            ]);
            return riqAuthService.auth(altToken);
          }
          throw _err;
        })
        .then(featureService.getFeatures)
        .then(_onAuthSuccess)
        .then(sendAppStartEvent)
        .catch(function(_err) {
          const hash = window.location.hash.replace('#/', '');
          localStorage.setItem('deepLinkRedirect', hash);

          if (_err.code === 210001 && !applicationDebug) {
            window.location = '/login';
            return;
          }

          // Sometimes the API fails with an empty non standard response. When that happen we redirect to login page.
          if (isMobile.any && !applicationDebug) {
            window.location = '/download-app';
            return;
          }

          // Rely on apiService and errorHandlerService to handle invalid tokens. The catch is prevent the error from triggering the error-page befoer redirecting the user to the login page.
          if (applicationDebug) {
            throw _err;
          }
          return riqAuthService.logout('/login');
        });
    }
    if (applicationDebug) {
      return riqErrorHandlerService.invalidToken(
        _errFn('NoToken', 'Could not find user token')
      );
    }

    const hash = window.location.hash.replace('#/', '');
    localStorage.setItem('deepLinkRedirect', hash);
    window.location = '/login';
  };
};

export default initServiceImpl;
